/**
 * @name UnlockUser
 * @description Componente para desbloquear a los usuarios de Talentry
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { Redirect } from 'react-router-dom';

import { Lines } from '@components';
import { AuthService, PasswordService, ResponseHandlerService, SnackbarService } from '@services';
import { Layout, MUI, Typography } from '@styles';

class UnlockUser extends Component {
  constructor(props) {
    super(props);
    let URLParams = `${props.location.search}${props.location.hash}`;
    let queryParams = new URLSearchParams(URLParams);

    this.state = {
      employeeId: encodeURIComponent(queryParams.get('IdEmpleado')),
      enterpriseId: encodeURIComponent(queryParams.get('IdEmpresa')),
      token: encodeURIComponent(queryParams.get('token')),
      date: queryParams.get('FechaVencimiento'),
      isUserUnlocked: false
    };
  }

  componentDidMount() {
    const { employeeId, enterpriseId, date, token } = this.state;

    if (Date(date) < new Date()) {
      SnackbarService.error(i18n.t('HttpResponse.error'));
    } else {
      if (employeeId !== 'null' && enterpriseId !== 'null' && token !== 'null') {
        PasswordService.unlockUser({
          IdEmpleado: employeeId,
          IdEmpresa: enterpriseId,
        }).then((response) => {
          this.setState({ isUserUnlocked: true });
          ResponseHandlerService.success(response);
        }).catch(() => {
          SnackbarService.error(i18n.t('HttpResponse.error'));
        });
      }
    }
  }

  // Redirect to Login
  goLogin = () => {
    const { history } = this.props;
    history.push('/login');
  }

  render() {
    const { isUserUnlocked } = this.state;
    const isAuth = AuthService.authentication.isAuth;
    return (
      <>
        {isAuth && <Redirect to={{ pathname: '/' }} />}
        <Layout.ContentWrapper>
          <MUI.Box margin="16px">
            <Typography.H2>
              {i18n.t('UnlockUser.unlockAccount')}
            </Typography.H2>
          </MUI.Box>
          <MUI.Box margin="16px">
            <Lines
              direction="horizontal"
              firstLine={{ size: 75, color: 'blueMedium' }}
              secondLine={{ size: 25, color: 'red' }}
            />
          </MUI.Box>
          <MUI.Box padding="16px">
            <MUI.Box marginBottom="16px">
              {!isUserUnlocked ? (
                <Typography.Text>
                  {i18n.t('UnlockUser.emailExpiredMSG')}
                </Typography.Text>
              ) : (
                  <Typography.Text>
                    {i18n.t('UnlockUser.userUnlocked')}
                  </Typography.Text>
                )}
            </MUI.Box>
            <MUI.ButtonCTA
              type="button"
              color="primary"
              onClick={this.goLogin}
              margin="false"
            >
              {i18n.t('GenericMessages.goTalentry')}
            </MUI.ButtonCTA>
          </MUI.Box>
        </Layout.ContentWrapper>
      </>
    );
  }
}

UnlockUser.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
};

export default UnlockUser;